import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "components/card";
import {
    FileArchive,
} from "lucide-react"
import EmployeeDocumentsTabs from "./DocumentsTab";
import {
    getEmployeeDocumentList,
} from "../../../../../redux/document/documentState";
import { useParams } from 'react-router-dom';

const EmployeeDocuments = ({
    recordList, 
    recordData,
}) => {
    const { detailId } = useParams();

    const dispatch = useDispatch();
    const documentList = useSelector((state) => state.document.employeeDocumentList?.items);
        
    useEffect(() => {
        if(recordData){
            dispatch(getEmployeeDocumentList({recordId: recordData.emp_id }));
        }
    }, [dispatch, recordData]);

    const employeeName = recordData?.employee_name ;
    const employeeCode = recordData?.emp_code;

    return (
        <div className="flex flex-col space-y-6">
            {/* <AccessButton
                backLabel="Back to Employee Details"
                withBack={true}
                baseRoute="/console/employee-details"
            /> */}
            <>
                <div className="space-y-6">
                    <Card className="flex flex-col gap-6 rounded-xl border border-emerald-200 bg-gradient-to-br from-white to-emerald-50/30 
                                    dark:from-white/10 dark:to-emerald-900">
                        <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 
                                        grid-cols-[1fr_auto] [.border-b]:pb-6"
                        >
                            <div className="flex items-center gap-3">
                                <div className="p-3 rounded-lg bg-emerald-100">
                                    <FileArchive className="w-6 h-6 text-emerald-600" />
                                </div>
                                <div>
                                    <h4 className="text-[18px] title-text">Employee Documents & Contracts</h4>
                                    <p className="muted-text">
                                        All documents for {employeeName} ({employeeCode})
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Card>
                    <div className="flex flex-col gap-2 w-full">
                        <EmployeeDocumentsTabs documents={documentList || []} />
                    </div>
                </div>
            </>
        </div>
    );
}


export default EmployeeDocuments;